import { useMemo } from 'react';

import type { ColumnFiltersState } from '@tanstack/react-table';

import {
  energyTransitionModules,
  FILTER_KEYS,
  NEW_DATA_URL_PARAM,
  oilOnlyModules
} from '../constants';
import type { FilterState } from '../types/filter.types';

// `Code` carries no entry here: "show selected only" is applied as a `rows`
// override in `useCatalog` (see `frozenRowIds`), not a column filter, and the
// single-code URL param (`filters.code`) is a pre-table data filter via
// `useCodeFilteredData` — neither belongs in the table's own filter state.
export const useCatalogColumnFilters = ({
  filters,
  showDiscontinued
}: {
  filters: FilterState;
  showDiscontinued: boolean;
}): ColumnFiltersState => {
  const only = filters.only;

  return useMemo((): ColumnFiltersState => {
    const result: ColumnFiltersState = [
      { id: 'Status', value: showDiscontinued },
      { id: 'LaunchDate', value: filters[NEW_DATA_URL_PARAM] }
    ];

    for (const key of Object.values(FILTER_KEYS)) {
      if (key === FILTER_KEYS.INDEX_MODULE) continue;
      const value = filters[key as keyof typeof filters];
      if (Array.isArray(value) && value.length > 0) {
        result.push({ id: key, value });
      }
    }

    const indexModuleValues = filters[FILTER_KEYS.INDEX_MODULE];
    if (indexModuleValues.length > 0) {
      result.push({ id: 'IndexModule', value: indexModuleValues });
    } else if (only === 'oil') {
      result.push({ id: 'IndexModule', value: oilOnlyModules });
    } else if (only === 'energyTransition') {
      result.push({ id: 'IndexModule', value: energyTransitionModules });
    }

    return result;
  }, [filters, only, showDiscontinued]);
};
